import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Service/defend/LocalRegulatory/LocalRegulatory.tsx");
